// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CircleArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M.417 7.5a6.583 6.583 0 1 1 13.166 0 6.583 6.583 0 0 1-13.166 0ZM5 4.15a.79.79 0 0 0 .288.604l2.818 2.67-2.775 2.629a.79.79 0 0 0-.331.629c0 .452.383.818.857.818a.874.874 0 0 0 .607-.241l3.458-3.28a.784.784 0 0 0 .245-.562.782.782 0 0 0-.24-.555L6.47 3.582a.872.872 0 0 0-.612-.249c-.474 0-.857.366-.857.818Z"
			fill="#555BE4"
		/>
	</svg>
);
export default CircleArrow;
